module.exports = __webpack_public_path__ + "img/pexels-katerina-holmes-5905709.eb949dc9.jpg";